import React, { useState } from "react";
import OccasionAndNeedTable from "./OccasionAndNeedTable";

const NeedsCompareOccasion = ({
  needsCmpOccasion,
  needCmpOccasionQuestion,
  loading,
}) => {
  const [indexChecked, setIndexChecked] = useState(false);

  const handleIndexToggle = (checked) => {
    setIndexChecked(checked);
  };

  return (
    <div className="occasion-overall">
      <OccasionAndNeedTable
        headerText={
          <span>
            XMOT<sup>&reg;</sup> needs - Compare Occasion
          </span>
        }
        headerSubTitle={
          <span>
            Base: XMOT<sup>&reg;</sup> Surveys
          </span>
        }
        subTitle={`% of total responses by occasion`}
        tableData={needsCmpOccasion}
        question={needCmpOccasionQuestion}
        handleIndexToggle={handleIndexToggle}
        indexChecked={indexChecked}
        loading={loading}
      />
    </div>
  );
};

export default NeedsCompareOccasion;
